export default [
    require('./app-store-categories').default,
    require('./ad-setup').default,
    require('./budget-revenue-model').default,
    require('./campaign-setup').default,
    require('./content-restrictions').default,
    require('./getting-started').default,
    require('./whats-new').default,
];
